<template lang="pug">
v-row(no-gutters align="center" justify="center" class=" tw-bg-white tw-shadow-md  tw-z-40")
  v-col(cols="auto")
    template(v-if="website.logo")
      v-img(:src="path(website.logo)" class="tw-w-24 tw-h-24 tw-mx-6")
    template(v-else)
      span(:class="titleColor" class=" tw-text-lg tw-font-bold") realtor
  v-col(cols="auto")
    v-row(no-gutters class=" theme-d-header ")
      v-col(cols="auto" v-if="website.pages.home.published")
        v-btn(
          small
          :to="`/website`"
          height="100%"
          width="80px"
          elevation="0"
          text
          exact
          active-class="theme-d-menu-active"
          class="tw-p-0 tw-m-0 tw-rounded"
        )
          span(class=" tw-text-orange-darken-4 tw-capitalize tw-font-bold font-poppins") {{ website.pages.home.name }}
      v-col(cols="auto" v-if="website.pages.rent.published")
        v-btn(
          small
          :to="`/website/rent`"
          height="45px"
          width="80px"
          elevation="0"
          text
          exact
          active-class="theme-d-menu-active"
          class="tw-p-0 tw-m-0 tw-rounded"
        )
          span(class=" tw-text-orange-darken-4 tw-capitalize tw-font-bold font-poppins") {{ website.pages.rent.name }}
      v-col(cols="auto" v-if="website.pages.buy.published")
        v-btn(
          small
          :to="`/website/sale`"
          height="45px"
          width="80px"
          elevation="0"
          text
          exact
          active-class="theme-d-menu-active"
          class="tw-p-0 tw-m-0 tw-rounded"
        )
          span(class=" tw-text-orange-darken-4 tw-capitalize tw-font-bold font-poppins") {{ website.pages.buy.name }}
      v-col(cols="auto" v-if="website.pages.about.published")
        v-btn(
          small
          :to="`/website/${website.pages.about.slug}`"
          height="45px"
          width="80px"
          elevation="0"
          text
          exact
          active-class="theme-d-menu-active"
          class="tw-p-0 tw-m-0 tw-rounded"
        )
          span(class=" tw-text-orange-darken-4 tw-capitalize tw-font-bold font-poppins") {{ website.pages.about.name }}
      v-col(cols="auto" v-if="website.pages.contact.published")
        v-btn(
          small
          :to="`/website/${website.pages.contact.slug}`"
          height="45px"
          width="80px"
          elevation="0"
          text
          exact
          active-class="theme-d-menu-active"
          class="tw-p-0 tw-m-0 tw-rounded"
        )
          span(class=" tw-text-orange-darken-4 tw-capitalize tw-font-bold font-poppins") {{ website.pages.contact.name }}
</template>
<script>
export default {
  computed: {
    website() {
      return this.$store.getters['website/website'];
    },
  },
};
</script>
<style>
.theme-d-menu-active {
  background-color: rgba(230, 81, 0, 0.21) !important;
}
</style>
